export default "__VITE_ASSET__DQ9T044P__"